import { ReactNode } from 'react';
import { View } from 'react-native-animatable';

type Props = {
  leftGrid: ReactNode;
  rightGrid: ReactNode;
};

export const SelectLayout = ({ leftGrid, rightGrid }: Props) => {
  return (
    <View className="w-full h-full flex-wrap">
      <View className="h-full w-3/4">{leftGrid}</View>
      <View className="w-1/4 h-full justify-around items-center">
        {rightGrid}
      </View>
    </View>
  );
};
